window.I18N = window.I18N || {};
window.I18N.en = {
  common: {
    t001: 'Settings',
    t002: 'Appearance settings',
    t003: 'Appearance',
    t004: 'Language · 语言',
    t005: 'Light themes',
    t006: 'Dark themes',
    t007: 'Accent',
    t008: 'Font size',
    t009: 'Reset to defaults',
    t010: 'Sitemap',
    t011: 'Contact',
    t012: 'Shenzhen, China',
    t013: 'Qualified investors only',
    t014: 'User login',
    t015: 'Access fund letters, NAV reports and LP meeting minutes.',
    t016: 'Email / ID',
    t017: 'your.email@example.com',
    t018: 'Password',
    t019: 'Sign in',
    t020: 'Forgot password',
    t021: 'Request access',
    t022: 'Sign in / Register',
    t023: 'Shenzhen Qianhai Kexi Capital Management Co., Ltd. — private equity focused on semiconductors and hard tech.',
    t024: '© 2016 – 2026 KEXI CAPITAL · 备案号 P1060401',
    t025: 'WC',
    t026: 'WB',
    t027: 'in',
    t028: 'Managing Partner',
  },
  main: {
    t001: 'EST. 2016 · Shenzhen Qianhai',
    t002: 'See listed companies',
    t003: '· FIRM SNAPSHOT · 2026 Q1',
    t004: 'Montage exit return',
    t005: 'Listed / soon-to-list portfolio',
    t006: 'cos',
    t007: 'Registered funds',
    t008: '',
    t009: 'AUM',
    t010: 'B RMB',
    t011: 'A decade in, still going long',
    t012: 'Founded in 2016 from Shenzhen Qianhai, Kexi Capital concentrates on semiconductors, AI, life sciences and commercial aerospace. We deploy through focused single-asset funds — partners run diligence themselves, building conviction round by round, alongside the founders.',
    t013: '/ PLACEHOLDER · Qianhai skyline',
    t014: 'Manager profile',
    t015: 'Founded in February 2016 and registered with AMAC in December 2016 (Code P1060401), Kexi is a licensed private equity manager focused on hard tech.',
    t016: 'Read the full story',
    t017: 'Four conviction tracks',
    t018: 'We don\'t spread thin. Deep concentration across semiconductors, AI & intelligent driving, life sciences, and smart manufacturing & aerospace — the hard-tech substrate of China\'s substitution decade.',
    t019: 'View strategy',
    t020: 'Time, made tangible',
    t021: 'View all listed cases',
    t022: 'Full portfolio',
    t023: 'The next windows opening',
    t024: 'How we think about this',
    t025: 'Investing is an experiment in time. In hard tech the rare commodity isn\'t insight — it\'s patience.',
    t026: 'PARTNER WITH US',
    t027: 'Stake the high',
    t028: 'US-China decoupling, localisation, technology cycles in motion. The next decade of semiconductors, smart hardware and biotech is opening. Whether you\'re a qualified LP or a founder seeking capital, we welcome the conversation.',
    t029: 'POINT OF CONTACT',
    t030: 'PHONE / WECHAT',
    t031: 'ADDRESS',
    t032: 'Get in touch',
    t033: 'About Kexi Capital',
    t034: 'Founded at the inflection',
    t035: 'of a technology cycle.',
    t036: '/ PLACEHOLDER · Office / Shenzhen Qianhai',
    t037: 'Manager Overview',
    t038: 'Shenzhen Qianhai Kexi Capital Management Co., Ltd. was founded in February 2016. The firm was registered with the Asset Management Association of China on December 9, 2016 (Code P1060401), as a licensed private equity manager.',
    t039: 'We currently manage 15 registered funds with nearly ¥2 B AUM — two blind-pool funds and thirteen single-asset vehicles. Open mandates include the Commercial Aerospace Fund (¥300 M), a Fund-of-Funds (¥200 M) and a single-asset fund (¥100 M).',
    t040: 'Founded',
    t041: 'AMAC code',
    t042: 'Funds',
    t043: '≈ ¥2 B',
    t044: 'A decade of pace',
    t045: 'One fund, one call, one judgement vindicated by time — year by year.',
    t046: 'Partners run their own diligence',
    t047: 'There is no analyst pyramid. Partners own every investment from first meeting to post-investment — which is why our book is never average.',
    t048: '/ PLACEHOLDER · Portrait',
    t049: 'On hard tech, real returns come from time × density. Give time to the right founders, and to only a few — that\'s all of what we do.',
    t050: 'WANG ZHEN · MANAGING PARTNER',
    t051: 'Investment Strategy',
    t052: 'Narrow tracks,',
    t053: 'Focus isn\'t a slogan, it\'s the cap table. Of 15 funds, 90%+ capital sits on four tracks — that is why one diligence framework keeps compounding cycle after cycle.',
    t054: 'Early & mid stage',
    t055: 'Focus across semiconductors, life sciences, smart manufacturing, AI and commercial aerospace — angel to Series B, doubling down round by round.',
    t056: 'Late & Pre-IPO',
    t057: 'Centred on semiconductors, plus growth follow-ons in our own earlier conviction names — turning certainty into realised certainty.',
    t058: 'Focus is what we don\'t do',
    t059: 'Four principles, written down',
    t060: 'Convinced by conviction',
    t061: 'See our 7 listed companies, the pre-IPO pipeline and the early-stage book.',
    t062: 'View portfolio',
    num01: '01 / The Firm',
    num02: '02 / Sectors',
    num03: '03 / Listed Companies',
    num04: '04 / Pre-IPO Pipeline',
    num05: '05 / Philosophy',
    num06: '01 / Milestones',
    num07: '02 / The Team',
    num08: '01 / Four Tracks',
    num09: '02 / Philosophy',
    kMilestones: 'MILESTONES',
    kTheTeam: 'THE TEAM',
    foundDate: '2016.02',
    regCode: 'P1060401',
    yearsCount: '15',
    kFirm: 'THE FIRM',
    kSectors: 'SECTORS',
    kListed: 'LISTED COMPANIES',
    kPipeline: 'PRE-IPO PIPELINE',
    kPhilosophy: 'PHILOSOPHY',
    heroL1: 'Patient capital,',
    heroL2a: 'conviction',
    heroL2b: 'compounds.',
    num04b: '04 / Pre-IPO Pipeline',
    heroN1: '20',
    heroN2: '9',
    heroN3: '15',
    heroN4: '20',
    heroU1: '×',
    heroU2: 'cos',
    heroU3: '',
    heroU4: 'B RMB',
    statN1: '20',
    statN2: '15',
    statN3: '20',
    statN4: '7',
    statU1: 'x',
    statU2: 'funds',
    statU3: 'B RMB',
    statU4: '+',
    secEx1: 'Montage / SmartSens / Smarter Micro / Basic Semi / SemiPower',
    secEx2: 'Black Sesame / MINIEYE / DataCanvas / Dragonfly',
    secEx3: 'GeneMind / HuaYuan Regenerative',
    secEx4: 'KuaiZao / RayLi / CECS',
    philoNum1: 'I.',
    philoNum2: 'II.',
    philoNum3: 'III.',
    philoNum4: 'IV.',
    brandNameCn: '深圳前海珂玺资本管理有限公司',
    brandNameEn: 'Shenzhen Qianhai Kexi Capital Management Co., Ltd.',
    collabL2: 'ground together.',
    philoSub1: '',
    philoSub2: '',
    philoSub3: '',
    philoSub4: '',
    secSub1: '',
    secSub2: '',
    secSub3: '',
    secSub4: '',
    caseSub1: '',
    caseSub2: '',
    caseSub3: '',
    case1_ticker: '688008', case1_year: '2019.07', case1_glyph: 'Montage', case1_title: 'Montage Technology',
    case1_desc: 'World-leading data-processing and interconnect IC designer. One of only three global players in memory interface chips, holding 45% market share.',
    case1_market: 'STAR Market', case1_ret: '20', case1_retLabel: 'exit multiple',
    case2_ticker: '688213', case2_year: '2022.05', case2_glyph: 'SmartSens', case2_title: 'SmartSens',
    case2_desc: 'Advanced CMOS image sensor designer for security, machine vision and automotive applications.',
    case2_market: 'STAR Market', case2_ret: '50', case2_retLabel: '% post-lockup return',
    case3_ticker: '688512', case3_year: '2023.05', case3_glyph: 'Smarter', case3_title: 'Smarter Micro',
    case3_desc: "Pioneer of the world's first reconfigurable RF front-end and consistent leader in 5G RFFE solutions.",
    case3_market: 'STAR Market', case3_ret: '', case3_retLabel: 'Listed',
    pipe1_year: '2025', pipe1_title: 'Basic Semi', pipe1_sector: 'SiC', pipe1_status: 'Offshore filing approved',
    pipe2_year: '2026', pipe2_title: 'Fengjia Tech', pipe2_sector: 'Mixed-signal IC', pipe2_status: 'HKEX submission planned',
    pipe3_year: '2026', pipe3_title: 'Ferrotec Hi-purity', pipe3_sector: 'Silicon consumables', pipe3_status: 'ChiNext filing planned',
    pipe4_year: '2026', pipe4_title: 'GeneMind', pipe4_sector: 'Sequencing', pipe4_status: 'Restructuring initiated',
    pipe5_year: '2026', pipe5_title: 'DataCanvas', pipe5_sector: 'AI Infrastructure', pipe5_status: 'HKEX submission planned',
    t052b: 'deep conviction.',
    stKickA: 'A / EARLY-TO-MID',
    stKickB: 'B / LATE-TO-PE',
    stFourKicker: 'THE FOUR TRACKS',
    stTagsA: 'Semiconductors / Life Sciences / Smart Mfg / AI / Aerospace',
    stTagsB: 'Semi follow-on / FoF / Single-asset / IPO coaching',
    stTrack1Cn: 'Semiconductors', stTrack1Sub: '', stTrack1Ex: 'Montage / SmartSens / Smarter Micro / Basic Semi / SemiPower',
    stTrack2Cn: 'AI & Intelligent Driving', stTrack2Sub: '', stTrack2Ex: 'Black Sesame / MINIEYE / DataCanvas / Dragonfly',
    stTrack3Cn: 'Biotech & Life Sciences', stTrack3Sub: '', stTrack3Ex: 'GeneMind / HuaYuan Regenerative',
    stTrack4Cn: 'Smart Manufacturing & Aerospace', stTrack4Sub: '', stTrack4Ex: 'KuaiZao / RayLi / CECS',
    stPhilo1Num: 'I.', stPhilo2Num: 'II.', stPhilo3Num: 'III.', stPhilo4Num: 'IV.',
  },
  portfolio: {
    t001: 'Portfolio',
    t002: 'Companies we\'ve',
    t003: 'From Montage to Basic Semi, from Feiyu to Zhongtian Crystal — the full book by stage. Tap any company to expand.',
    t004: 'Listed',
    t005: 'Pre-IPO pipeline',
    t006: 'Early-stage book',
    t007: 'Companies backed',
    t008: 'A handful of names worth repeating — they shape ten years of our story.',
    kLogoWall: 'LOGO WALL',
    t009: 'Listed Companies',
    t010: 'Returns,',
    t011: 'Four on STAR, two on HKEX, one reverse-merger — the most direct footnote to a decade of time × density.',
    t012: 'STAR Market listings',
    t013: 'HKEX listings',
    t014: 'Reverse-merger listing',
    t015: 'Montage exit multiple',
    t016: 'Case by case',
    t017: 'Tap any row to expand the investment trajectory, exit milestones and realised return.',
    t018: 'Case study · Montage',
    t019: 'A 20× exit,',
    t020: 'Montage is one of only three global designers of memory interface chips, holding 45% market share. Intel took a 10% stake for US$170 M in 2018; Montage joined the inaugural STAR batch in 2019 and broke ¥100 B market cap on day one.',
    t021: 'Kexi invests',
    t022: 'Intel strategic stake',
    t023: 'STAR Market IPO',
    t024: '20× exit',
    t025: 'Coming soon',
    t026: 'cos',
    t027: 'Investment trajectory',
    t028: 'Key facts',
    t029: 'Ticker',
    t030: 'Listing venue',
    t031: 'IPO date',
    t032: 'Sector',
    num01: '01 / Case Studies',
    num02: '02 / Logo Wall',
    casesReturn: 'made tangible.',
    casesStat1: '4', casesStat2: '2', casesStat3: '1', casesStat4: '20',
    kCaseByCase: 'CASE BY CASE',
    kThePipeline: 'PRE-IPO PIPELINE',
    casesWallTitle: 'Pre-IPO Pipeline',
  },
  aux: {
    t001: 'News & Insights',
    t002: 'What we see,',
    t003: 'Investment updates, IPO milestones, and our notes on semiconductors and frontier tech.',
    t004: '/ COVER · Seeya IPO',
    t005: 'Joined Seeya\'s Series B in 2021 alongside Shanghai Aviation and Xiaomi Industry. Five years later, STAR Market debut on March 25, 2026.',
    t006: 'Read more',
    t007: 'Editor\'s pick',
    t008: 'Get in touch',
    t009: 'Stake the high',
    t010: 'Whether you are a qualified LP, a founder, an industry researcher or one of our portfolio partners — we welcome the conversation.',
    t011: 'Headquarters',
    t012: 'Point of contact',
    t013: 'Phone / WeChat',
    t014: 'WeChat ID',
    t015: 'Email',
    t016: 'Office hours',
    t017: 'Send a note',
    t018: 'Tell us who you are.',
    t019: 'Name',
    t020: 'Organisation',
    t021: 'Phone',
    t022: 'I am a',
    t023: 'Qualified LP',
    t024: 'Founder seeking capital',
    t025: 'Industry / research',
    t026: 'Other',
    t027: 'Your message',
    t028: 'Briefly — we\'ll respond within 3 business days.',
    t029: 'Send',
    t030: '/ MAP · Shenzhen Qianhai · Unisplendour Info Port Tower B',
    t031: 'SHENZHEN · NANSHAN · QIANHAI',
    t032: 'Careers',
    t033: 'Work where the',
    t034: 'We\'re a small, partner-led team. No analyst pyramid — every member contributes to decisions and owns outcomes.',
    t035: 'We\'re looking for',
    t036: 'Kexi Capital',
    t037: 'LOCATION',
    t038: 'EXP',
    t039: 'TYPE',
    t040: 'Don\'t see your role?',
    t041: 'We always welcome strong candidates for hard-tech investment. Send your CV to hr@kexicapital.com.',
    t042: 'Message received',
    t043: "We'll reach out via email or phone within 2 business days.",
    t044: 'Send another',
    t045: 'Attachments (optional)',
    t046: 'Click to choose files · multiple (≤20MB each, up to 10)',
    t047: 'ground together.',
    t048: 'Open in Amap →',
    t049: 'long game matters.',
    t050: 'Depth in every call',
    t051: "You'll join the front line of diligence and the IC — not an execution machine.",
    t052: 'Long-horizon ownership',
    t053: 'We think in years, not quarters — and pay accordingly.',
    t054: 'Verified by time',
    t055: "Your judgements enter the firm's knowledge stack and compound.",
    t056: '01.',
    t057: '02.',
    t058: '03.',
    t059: 'what we record.',
    num01: '01 / Open Roles',
  },
  studio: {
    t001: 'Kexi Studio · Research Service',
    t002: 'Give us the materials,',
    t003: 'From files to conviction · in four steps',
    t004: 'AI extracts the facts, analysts vet the logic. We neither trust AI blindly nor ignore the speed it brings — every claim traces back to the source line.',
    t005: 'Get started',
    t006: 'Drop files or browse. After submission you enter the review queue. Approved qualified LPs can see deliverables in \'My reports\'.',
    t007: 'files',
    t008: 'Sign in required',
    t009: 'Approved LPs see history, reports and bespoke mini-sites once signed in.',
    t010: 'Sign in',
    t011: '· Sample preview',
    t012: 'Cases on the wall',
    t013: 'The reports and mini-sites below were published with the author\'s consent. Tap any tile to visit its dedicated site.',
    t014: 'pages',
    t015: 'Visit site →',
    t016: 'Access notes',
    t017: 'Studio is currently open to',
    t018: 'Approved LPs, portfolio founders and institutional partners under NDA. For other inquiries, write to studio@kexicapital.com.',
    t019: 'Submit BP · For founders',
    t020: 'Tell us what',
    t021: 'One form, five minutes.',
    t022: 'Fill in the form and attach your deck (PDF / PPT, ≤ 30 MB). If your project doesn\'t fit our mandate, we\'ll refer it to peers who might be a better match.',
    t023: 'Sectors we focus on',
    t024: 'Submission received',
    t025: 'We\'ve received your materials. A partner will reply within 5 business days — regardless of outcome.',
    t026: 'Submit another',
    t027: 'Founder name',
    t028: 'Company',
    t029: 'Email',
    t030: 'Phone / WeChat',
    t031: 'Sector',
    t032: 'Stage',
    t033: 'Round size · Valuation',
    t034: 'e.g. ¥50M raise · ¥400M pre',
    t035: 'One-line pitch',
    t036: 'e.g. The only domestic 8-inch SiC epi at volume',
    t037: 'More detail · optional',
    t038: 'Market, team, moat, milestones...',
    t039: 'Deck · PDF / PPT',
    t040: 'Click or drop your deck',
    t041: 'I have read Kexi\'s confidentiality undertaking. The materials are used solely for investment review and will be kept strictly confidential.',
    t042: 'Submit deck',
    t043: 'They started here, too',
    t044: 'Companies we\'ve taken public',
    t045: 'you\'re building.',
    t046: 'we return judgement.',
    k1: 'HOW IT WORKS',
    k2: 'SUBMIT MATERIALS',
    k3: 'PUBLIC SHOWCASE',
    step1: 'STEP / 01',
    step2: 'STEP / 02',
    step3: 'STEP / 03',
    step4: 'STEP / 04',
    member: 'MEMBERS',
    email: 'studio@kexicapital.com',
    regLogin: 'Register / Sign in',
    regHint: 'Register or sign in to upload materials and view your reports.',
    analyst: 'analyst',
    num01: '01 / Workflow',
    num02: '02 / Submit Materials',
    num03: '03 / Public Showcase',
    num04: '01 / Submit',
  },
};
